import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    texts: {
      "title": "ACTIVATE EXTENDED WARRANTY NOW",
    },
    email: "abc@example.com",
    emailHref: "mailto: abc@example.com?subject=Feedback&body=Message",
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
